/**
 * @file StageDeleteDialog.tsx
 * @description Подтверждение удаления стадии (phase19.31; было
 * `window.confirm`). Окно кабинета, на телефоне — на весь экран; удаление —
 * красной кнопкой подтверждения, как у остальных опасных действий.
 */

import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "../../ui/alert-dialog";
import { Button } from "../../ui/button";

interface Props {
  /** Название удаляемой стадии; `null` — окно закрыто. */
  name: string | null;
  busy: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

export function StageDeleteDialog({ name, busy, onCancel, onConfirm }: Props) {
  return (
    <AlertDialog open={name !== null} onOpenChange={(open) => (!open ? onCancel() : null)}>
      <AlertDialogContent fullScreen className="max-w-md gap-3">
        <AlertDialogHeader>
          <AlertDialogTitle>Удалить стадию «{name}»?</AlertDialogTitle>
          <AlertDialogDescription>Стадия исчезнет из воронки и с доски. Записей на ней нет.</AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <Button variant="ghost" onClick={onCancel} disabled={busy}>
            Не удалять
          </Button>
          <Button variant="destructive-solid" onClick={onConfirm} disabled={busy} loading={busy}>
            Удалить стадию
          </Button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
